(function(wtcpJs) {
    "use strict";
    let guid = require('guid');
    class PrivateTextMessageRequest {
        constructor(obj) {
            this.conversationId = "";
            this.label = "";
            this.participants = [];
            this.metaData = [];
            this.mimeType = 'text/plain; charset=utf8';
            this.data = ''; 
            this.destination = {
                userName: '', 
                displayName: '', 
                callAlias: '' 
            };

            if(!obj || !obj.conversationId)
            {
                this.conversationId = guid.create().value;
            } else {
                this.conversationId = obj.conversationId;
            }
        }
    }

    wtcpJs.PrivateTextMessageRequest = PrivateTextMessageRequest;
})(WtcpJs || (WtcpJs = {}));